module.exports = "/_next/static/videos/slide-2-b890918f7c05d96965462a3422cd81f9.webm";